<script setup lang="ts">
import { computed } from 'vue'
import { useIdeStore } from '@/stores/ide.store'
const ideStore = useIdeStore()
const showOutputFiles = computed(() => {
  return ideStore.isOutputFiles && ideStore.isOutputFiles.length > 0
})
</script>

<template>
  <div class="flex items-center justify-center gap-x-1 whitespace-nowrap">
    Generated files
    <span
      v-if="showOutputFiles"
      class="background-quaternary stroke-primary-default inline-flex items-center rounded-full border border-opacity-30 px-1.5 py-0.5 text-xs font-medium leading-3"
    >
      {{ ideStore.isOutputFiles.length }}
    </span>
  </div>
</template>
